import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      <div className="terms-header container">
        <h1>이용약관</h1>
      </div>

      <div className="terms-content container">
        <section className="terms-section">
          <h2>1. 목적</h2>
          <p>
            본 약관은 MIMIC(미믹) 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자의 권리/의무를 규정합니다.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. 서비스 제공</h2>
          <ul>
            <li>본 앱은 게스트/연동 계정으로 서비스를 제공하며, 사용 가능 시간 재화를 소모하여 앱 기능을 이용합니다.</li>
            <li>재화는 소모성 인앱 결제 상품으로 복원이 불가함을 명시합니다.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>3. 계정</h2>
          <ul>
            <li>회원은 Apple/Google 계정을 통해 연동할 수 있으며, 계정 삭제 시 정보는 즉시 폐기됩니다.</li>
            <li>게스트 상태로 구매한 데이터는 계정 연동 전에는 기기 변경 시 복구되지 않을 수 있습니다.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>4. 결제 및 환불</h2>
          <ul>
            <li>인앱 결제는 Apple/Google 결제 시스템만을 사용합니다.</li>
            <li>소모성 재화 특성 상 <strong>환불 정책은 각 앱스토어 정책을 따릅니다.</strong></li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>5. 책임 제한</h2>
          <ul>
            <li>서비스 이용 중 발생한 손해는 회사의 고의/중대한 과실이 없는 한 책임을 지지 않습니다.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>6. 약관 변경</h2>
          <ul>
            <li>본 약관 변경 시 앱 내 공지 또는 별도 안내를 통해 사전 알립니다.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>7. 문의</h2>
          <p>
            서비스 이용 관련 문의사항은 고객지원 이메일(<a className="link" href="mailto:master@mimic.blog">master@mimic.blog</a>)로 연락 주시기 바랍니다.
          </p>
        </section>
      </div>

      <div className="terms-footer container">
        <p>최종 수정일: 2025년 12월</p>
        <p>제공: 베네핏브로스 (BenefitBros)</p>
      </div>
    </div>
  );
};

export default TermsOfService;
